export default "__VITE_ASSET__BqdXBkHk__"